import React from 'react';
import MarkdownContent from './MarkdownContent';

const formatDate = (value) => (value
  ? new Date(value).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
  : null);

// The brief + files view of a card, as seen from outside the tracker. Shared by
// the Gem City page (/r/:token) and the submitter's page (/u/:token) so both
// sides always look at the same thing.
const RequestBrief = ({ request, fileUrl, zipUrl }) => (
  <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-xl ring-1 ring-black/5 dark:ring-white/10 overflow-hidden">
    <div className="p-8 sm:p-10 border-b border-gray-100 dark:border-gray-800">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        {request.labels.map(label => (
          <span
            key={label.text}
            className="text-[10px] font-black uppercase tracking-widest px-2.5 py-1 rounded-full text-white"
            style={{ backgroundColor: label.color }}
          >
            {label.text}
          </span>
        ))}
        {request.priority && request.priority !== 'Medium' && (
          <span className="text-[10px] font-black uppercase tracking-widest px-2.5 py-1 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300">
            {request.priority} priority
          </span>
        )}
      </div>

      <h1 className="text-3xl font-black tracking-tight text-gray-900 dark:text-gray-100">{request.title}</h1>

      <dl className="mt-4 flex flex-wrap gap-x-8 gap-y-2 text-sm">
        {request.dueDate && (
          <div>
            <dt className="text-[10px] font-black uppercase tracking-widest text-gray-400">Needed by</dt>
            <dd className="font-bold text-gray-900 dark:text-gray-100">{formatDate(request.dueDate)}</dd>
          </div>
        )}
        <div>
          <dt className="text-[10px] font-black uppercase tracking-widest text-gray-400">Submitted</dt>
          <dd className="font-bold text-gray-900 dark:text-gray-100">{formatDate(request.createdAt)}</dd>
        </div>
        {request.source && (
          <div>
            <dt className="text-[10px] font-black uppercase tracking-widest text-gray-400">From</dt>
            <dd className="font-bold text-gray-900 dark:text-gray-100">{request.source}</dd>
          </div>
        )}
      </dl>
    </div>

    {request.description && (
      <div className="p-8 sm:p-10 border-b border-gray-100 dark:border-gray-800">
        <h2 className="text-xs font-black uppercase tracking-widest text-gray-400 mb-4">The request</h2>
        <MarkdownContent content={request.description} />
      </div>
    )}

    <div className="p-8 sm:p-10">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xs font-black uppercase tracking-widest text-gray-400">
          Files ({request.attachments.length})
        </h2>
        {request.attachments.length > 1 && (
          <a
            href={zipUrl}
            className="text-xs font-black uppercase tracking-widest text-primary-blue hover:underline"
          >
            Download all as .zip
          </a>
        )}
      </div>

      {request.attachments.length ? (
        <ul className="divide-y divide-gray-100 dark:divide-gray-800">
          {request.attachments.map(file => (
            <li key={file.id} className="flex items-center justify-between gap-4 py-3">
              <span className="font-medium text-gray-800 dark:text-gray-200 break-all">{file.name}</span>
              <a
                href={fileUrl(file.id)}
                className="shrink-0 px-4 py-2 rounded-xl bg-primary-blue text-white text-xs font-black uppercase tracking-widest hover:opacity-90"
              >
                Download
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-gray-500">No files attached to this request.</p>
      )}
    </div>
  </div>
);

export default RequestBrief;
